import {combineReducers} from "redux";
import liveStreamingReducer from "./live-streaming/liveStreamingReducer";
import programInfoReducer from './program/programInfoReducer';
import scheduleInfoReducer from './schedule/scheduleInfoReducer';
import LanguageDetector from './language-detector/LanguageDetector'
import playlistReducer from './playlist/playlistReducer'
import subStatusReducer from './sub-status/subStatusReducer'
import signupReducer from './signup/signupReducer'
import sendOtpReducer from './send-otp/sendOtpReducer'
import otpVerifyReducer from "./otp-verify/otpVerifyReducer"

export default combineReducers({
    live_streaming: liveStreamingReducer,
    program_info: programInfoReducer,
    schedule_info: scheduleInfoReducer,
    language_detector: LanguageDetector,
    playlist: playlistReducer,
    user_sub_status: subStatusReducer,
    signup: signupReducer,
    send_opt: sendOtpReducer,
    otp_verify: otpVerifyReducer
});